import * as React from 'react';
import { FC, useState, useEffect, useRef, useCallback } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import spacing from 'src/constants/spacing';
import mediaQueries from 'src/constants/responsive';
import stylesheet from 'src/constants/stylesheet';
import PreviewItem from './PreviewItem';
import { useApi } from 'src/@context/Api';
import Loading from './Loading';
import DropDown from './DropDown';
import * as classNames from 'classnames';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            maxWidth: spacing.ContentMaxWidt,
            margin: '0 auto',
            boxSizing: 'content-box',
            [mediaQueries.Mobile]: {
                padding: '0 20px',
            },
            [mediaQueries.AfterMobile]: {
                padding: '0 60px',
            }
        },
        title: {
            ...stylesheet.TitleH1,
            maxWidth: 550,
            margin: '0 auto',
            textAlign: 'center',
            padding: '1em 0 .4em 0',

        },
        subtitle: {
            maxWidth: 550,
            textAlign: 'center',
            margin: '0 auto',
            paddingBottom: '1.5rem',
        },

        filterContainer: {
            display: 'flex',

            [mediaQueries.Mobile]: {
                flexDirection: 'column',
                maxWidth: 260,
                margin: '0 auto',
            },
            [mediaQueries.TabletPortrait]: {
                flexDirection: 'column',
                maxWidth: 400,
                margin: '0 auto',
            },
            [mediaQueries.TabletLandScape]: {
                justifyContent: 'center',
                marginBottom: '2rem',
                marginLeft: -spacing.Gutter.Tablet / 2,
                marginRight: -spacing.Gutter.Tablet / 2,
            },
            [mediaQueries.AfterTablet]: {
                justifyContent: 'center',
                marginBottom: '2rem',
            },
            [mediaQueries.Laptop]: {
                marginLeft: -spacing.Gutter.Laptop / 2,
                marginRight: -spacing.Gutter.Laptop / 2,
            },
            [mediaQueries.Desktop]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
            },
        },

        panels: {
            [mediaQueries.Mobile]: {},
            [mediaQueries.AfterMobile]: {
                display: 'flex',
                flexWrap: 'wrap',
            },
            [mediaQueries.Tablet]: {
                marginLeft: -spacing.Gutter.Tablet / 2,
                marginRight: -spacing.Gutter.Tablet / 2,
            },
            [mediaQueries.Laptop]: {
                marginLeft: -spacing.Gutter.Laptop / 2,
                marginRight: -spacing.Gutter.Laptop / 2,
            },
            [mediaQueries.Desktop]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
            },
        },

        filterElement: {
            [mediaQueries.BeforeTablet]: {
                flex: '0 0 100%',
                width: '100%',
                marginBottom: '1.5rem',
            },
            [mediaQueries.TabletPortrait]: {
                paddingLeft: spacing.Gutter.Tablet / 2,
                paddingRight: spacing.Gutter.Tablet / 2,
            },
            [mediaQueries.Laptop]: {
                paddingLeft: spacing.Gutter.Laptop / 2,
                paddingRight: spacing.Gutter.Laptop / 2,
            },
            [mediaQueries.Desktop]: {
                paddingLeft: spacing.Gutter.Desktop / 2,
                paddingRight: spacing.Gutter.Desktop / 2,
            },
        },
        targetGroupFilter: {

            [mediaQueries.BeforeTablet]: {
                zIndex: 5
            },
            [mediaQueries.TabletLandScape]: {
                flex: '0 0 200px',
                width: 200,
            },
            [mediaQueries.AfterTablet]: {
                flex: '0 0 200px',
                width: 200,
            },
        },
        labelsFilter: {

            [mediaQueries.BeforeTablet]: {
                zIndex: 4
            },
            [mediaQueries.TabletLandScape]: {
                flex: '0 0 200px',
                width: 200,
            },
            [mediaQueries.AfterTablet]: {
                flex: '0 0 200px',
                width: 200,
            },
        },
        productGroupFilter: {

            [mediaQueries.BeforeTablet]: {
                zIndex: 3
            },
            [mediaQueries.TabletLandScape]: {
                flex: '0 0 200px',
                width: 200,
            },
            [mediaQueries.AfterTablet]: {
                flex: '0 0 200px',
                width: 200,
            },
        },
        productTypeFilter: {

            [mediaQueries.BeforeTablet]: {
                zIndex: 2
            },
            [mediaQueries.TabletLandScape]: {
                flex: '0 0 200px',
                width: 200,
            },
            [mediaQueries.AfterTablet]: {
                flex: '0 0 200px',
                width: 200,
            },
        },

        tagsFilter: {
            [mediaQueries.BeforeTablet]: {
                zIndex: 1
            },
            [mediaQueries.TabletLandScape]: {
                flex: '0 0 200px',
                width: 200,
            },
            [mediaQueries.AfterTablet]: {
                flex: '0 0 200px',
                width: 200,
            },
        },

        panel: {
            boxSizing: 'border-box',
            [mediaQueries.Mobile]: {
                width: '100%',
                marginBottom: spacing.Gutter.Mobile * 2,
            },
            [mediaQueries.Tablet]: {
                paddingLeft: spacing.Gutter.Tablet / 2,
                paddingRight: spacing.Gutter.Tablet / 2,
                marginBottom: spacing.Gutter.Tablet * 2,
            },
            [mediaQueries.TabletPortrait]: {
                width: `${1 / 2 * 100}%`,
            },
            [mediaQueries.TabletLandScape]: {
                width: `${1 / 3 * 100}%`,
            },
            [mediaQueries.AfterTablet]: {
                width: `${1 / 3 * 100}%`,
            },
            [mediaQueries.Laptop]: {
                paddingLeft: spacing.Gutter.Laptop / 2,
                paddingRight: spacing.Gutter.Laptop / 2,
                marginBottom: spacing.Gutter.Laptop * 2,
            },
            [mediaQueries.Desktop]: {
                paddingLeft: spacing.Gutter.Desktop / 2,
                paddingRight: spacing.Gutter.Desktop / 2,
                marginBottom: spacing.Gutter.Desktop * 2,
            },
        },
    }));

export type ProductsProps = ProductsDto;
type Props = ProductsProps;

const Products: FC<Props> = (
    { 
        Title,
        UID,
        TargetGroupItems,
        LabelItems,
        ProductGroupItems,
        ProductTypeItems,
        Tags }) => {

    const cls = useStyles();

    const itemsToLoad = 9;
    const [hasMore, setHasMore] = useState<boolean>();
    const [count, setCount] = useState(0);

    const { fetchProductPreviews, app } = useApi();
    const [productItems, setProductItems] = useState<ProductPreviewDto[]>([]);
    const [targetGroup, setTargetGroup] = useState('');
    const [label, setLabel] = useState('');
    const [productGroup, setProductGroup] = useState('');
    const [productType, setProductType] = useState('');
    const [tags, setTags] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);

    const config = app && app.Config;
    const translationsItems = config && config.TranslationItems;
    const targetGroupTranslation = translationsItems && translationsItems.find(t => t.UID === 'products_target_group_filter');
    const labelTranslation = translationsItems && translationsItems.find(t => t.UID === 'products_label_filter');
    const productGroupTranslation = translationsItems && translationsItems.find(t => t.UID === 'products_product_group_filter');
    const productTypeTranslation = translationsItems && translationsItems.find(t => t.UID === 'products_product_type_filter');
    const tagsTranslation = translationsItems && translationsItems.find(t => t.UID === 'tags');

    const loadItems = async () => {
        if (loading) { return }
        setLoading(true);

        const response = await
            fetchProductPreviews(UID, count, itemsToLoad, targetGroup, label, productGroup, productType, tags);

        setProductItems(prevItems => {
            return [...prevItems, ...response]
        });

        setHasMore(response.length === itemsToLoad);
        setLoading(false)

    };

    const onTagsChange = (tag: string) => {
        if (tag === "") {
            setTags([]);
            return;
        }

        if (tags && tags.indexOf(tag) > -1) {

            const result = tags.splice(tags.indexOf(tag), 1);

            setTags(result);
        } else {
            setTags([...tags, tag])
        }
    }

    useEffect(() => {
        loadItems();
    }, [targetGroup, label, productGroup, productType, count, tags]);

    const options: IntersectionObserverInit = { threshold: 1 }
    const observer = useRef<IntersectionObserver>();
    const lastItemLoaded = useCallback((item) => {
        if (loading) { return }

        if (observer.current) { observer.current.disconnect() }

        observer.current = new IntersectionObserver(items => {
            if (items[0].isIntersecting && hasMore) {
                setCount(prevCount => prevCount + itemsToLoad);
            }
        }, options)

        if (item) {
            observer.current.observe(item);
        }
    }, [loading]);

    return (
        <section className={cls.root}>
            {Title &&
                <h1 className={cls.title}>{Title}</h1>
            }

            <div className={cls.filterContainer}>
                {TargetGroupItems &&
                    <div className={classNames(cls.filterElement, cls.targetGroupFilter)}>
                        <DropDown
                            title={targetGroupTranslation && targetGroupTranslation.Translation || ''}
                            options={TargetGroupItems.map(t => ({ title: t.Title, value: t.ObjectId }))}
                            isTags={false}
                            // tslint:disable-next-line:jsx-no-lambda
                            onChanged={(item) => {
                                setTargetGroup(item && item.value || '');
                                setHasMore(false);
                                setCount(0);
                                setProductItems([])
                            }}
                        />
                    </div>
                }
                {LabelItems &&
                    <div className={classNames(cls.filterElement, cls.labelsFilter)}>
                        <DropDown
                            title={labelTranslation && labelTranslation.Translation || ''}
                            options={LabelItems.map(t => ({ title: t.Title, value: t.ObjectId }))}
                            isTags={false}
                            // tslint:disable-next-line:jsx-no-lambda
                            onChanged={(item) => {
                                setLabel(item && item.value || '');
                                setHasMore(false);
                                setCount(0);
                                setProductItems([])
                            }}
                        />
                    </div>
                }
                {ProductGroupItems &&
                    <div className={classNames(cls.filterElement, cls.productGroupFilter)}>
                        <DropDown
                            title={productGroupTranslation && productGroupTranslation.Translation || ''}
                            options={ProductGroupItems.map(t => ({ title: t.Title, value: t.ObjectId }))}
                            isTags={false}
                            // tslint:disable-next-line:jsx-no-lambda
                            onChanged={(item) => {
                                setProductGroup(item && item.value || '');
                                setHasMore(false);
                                setCount(0);
                                setProductItems([])
                            }}
                        />
                    </div>
                }
                {ProductTypeItems &&
                    <div className={classNames(cls.filterElement, cls.productTypeFilter)}>
                        <DropDown
                            title={productTypeTranslation && productTypeTranslation.Translation || ''}
                            options={ProductTypeItems.map(t => ({ title: t.Title, value: t.ObjectId }))}
                            isTags={false}
                            // tslint:disable-next-line:jsx-no-lambda
                            onChanged={(item) => {
                                setProductType(item && item.value || '');
                                setHasMore(false);
                                setCount(0);
                                setProductItems([])
                            }}
                        />
                    </div>
                }
                {
                    Tags &&
                    <div className={classNames(cls.filterElement, cls.tagsFilter)}>
                        <DropDown
                            title={tagsTranslation && tagsTranslation.Translation || ''}
                            options={Tags.map(t => ({ title: t.Title, value: t.ObjectId }))}
                            isTags={true}
                            // tslint:disable-next-line:jsx-no-lambda
                            onChanged={(item) => {
                                onTagsChange(item && item.value || '');
                                setCount(0);
                                setHasMore(false);
                                setProductItems([]);
                            }}
                        />
                    </div>
                }
            </div>
            {productItems &&
                <article className={cls.panels}>
                    {productItems.map((product, i) => {
                        if (productItems.length === i + 1) {
                            return (
                                <div
                                    key={`product-${product.UID}`}
                                    className={cls.panel}
                                    ref={lastItemLoaded}
                                >
                                    <PreviewItem previewItem={product} />
                                </div>
                            );
                        } else {
                            return (
                                <div
                                    key={`product-${product.UID}`}
                                    className={cls.panel}
                                >
                                    <PreviewItem previewItem={product} />
                                </div>
                            );
                        }
                    })}
                </article>
            }
            {loading && <Loading />}
        </section>
    );
}

export default Products;


// WEBPACK FOOTER //
// ./src/Components/Products.tsx